import { render } from "./facture.vue?vue&type=template&id=30d7e7a6"
import script from "./facture.vue?vue&type=script&lang=js"
export * from "./facture.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__